module.exports = __webpack_public_path__ + "static/media/biteship-lazada.cc62bd5d.png";